export const INCLUDE_TAXES_AND_STATE_FEES = 'includeTaxesAndStateFees';
export const INCLUDE_ONLY_TAXES = 'includeOnlyTaxes';
